// src/slices/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import adminAxiosInstance from "../../api/adminAxiosInstance";
import { endpoints } from "../../api/endpoints";

// Define an async thunk for API call
export const CreateAdminUser = createAsyncThunk(
  "AdminAuthSlice/createnewadmin",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.adminSignup,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllAdmin = createAsyncThunk(
  "AdminAuthSlice/getAllAdmin",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.adminList,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const dltAdmin = createAsyncThunk(
  "AdminAuthSlice/dltAdmin",
  async (Data, { rejectWithValue }) => {
    try{
      const response = await adminAxiosInstance.post(
        endpoints.deleteAdmin,
        Data
      );
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
  }
)



// export const GetAllAdmins = createAsyncThunk();

// Create a slice
const apiSlice = createSlice({
  name: "AdminUserCreated",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
   extraReducers: (builder) => {
    builder
      .addCase(CreateAdminUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllAdmin.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(dltAdmin.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(CreateAdminUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getAllAdmin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(dltAdmin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(CreateAdminUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getAllAdmin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(dltAdmin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default apiSlice.reducer;
